/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboStructsDefendifySetting
 */
export interface JumboStructsDefendifySetting {
    /**
     * 
     * @type {Array<string>}
     * @memberof JumboStructsDefendifySetting
     */
    availableSettings?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsDefendifySetting
     */
    currentPolicyType?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsDefendifySetting
     */
    currentSetting?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsDefendifySetting
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsDefendifySetting
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsDefendifySetting
     */
    recommendedSettings?: string;
}

/**
 * Check if a given object implements the JumboStructsDefendifySetting interface.
 */
export function instanceOfJumboStructsDefendifySetting(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsDefendifySettingFromJSON(json: any): JumboStructsDefendifySetting {
    return JumboStructsDefendifySettingFromJSONTyped(json, false);
}

export function JumboStructsDefendifySettingFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsDefendifySetting {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'availableSettings': !exists(json, 'availableSettings') ? undefined : json['availableSettings'],
        'currentPolicyType': !exists(json, 'currentPolicyType') ? undefined : json['currentPolicyType'],
        'currentSetting': !exists(json, 'currentSetting') ? undefined : json['currentSetting'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'recommendedSettings': !exists(json, 'recommendedSettings') ? undefined : json['recommendedSettings'],
    };
}

export function JumboStructsDefendifySettingToJSON(value?: JumboStructsDefendifySetting | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'availableSettings': value.availableSettings,
        'currentPolicyType': value.currentPolicyType,
        'currentSetting': value.currentSetting,
        'displayName': value.displayName,
        'id': value.id,
        'recommendedSettings': value.recommendedSettings,
    };
}

